"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _organizations = require("@/api/organizations");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _settings = require("@/settings");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrganizationList',
  mixins: [_autoTableHeight.autoTableHeight],
  data: function data() {
    return {
      organizationList: [],
      tableLoading: false /* use for el-table */,
      total: 0,
      query: {
        page: 1,
        limit: _settings.pageSize,
        sort: 'createdAt:desc'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    hasPermission: function hasPermission(value) {
      return (0, _permission.default)(value);
    },
    doSearch: function doSearch(page) {
      this.query.page = page;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _organizations.getAllOrganizations)(token, this.query).then(function (response) {
        _this.organizationList = response.data.rows;
        _this.total = response.data.count;
        _this.tableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        _this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    assignUsers: function assignUsers(row) {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      var id = row.id;
      var emailDomains = row.emailDomains;
      var message = "\n  <div>\n    This will search all existing users who have the following email domain(s), and assign them to this organization. Continue?<br>\n    <ol style=\"padding-left: 20px; margin: 0;list-style-type: decimal;\">\n      ".concat(emailDomains.map(function (domain) {
        return "<li>".concat(domain, "</li>");
      }).join(''), "\n    </ol>\n  </div>\n");
      this.$confirm(message, 'Warning', {
        dangerouslyUseHTMLString: true,
        // 允许渲染 HTML
        type: 'warning'
      }).then(function () {
        var loadingInstance = _this2.$loading({
          // Show loading indicator
          lock: true,
          text: 'Processing...',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var formData = {
          organizationId: id
        };
        (0, _organizations.assignUsersToOrganization)(token, formData).then(function (response) {
          var msg = response.data.message;
          (0, _log.displayPopupMessage)(msg, 'success');
        }).catch(function (error) {
          (0, _log.showDebugLog)('assignUsersToOrganization-api-error', error);
          (0, _log.displayPopupMessage)(error, 'error');
        }).finally(function () {
          loadingInstance.close(); // Hide loading indicator when done (success or error)
        });
      }).catch(function () {
        var msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$parent.$emit('onSelectionChange', val);
    },
    sort: function sort(data) {
      var prop = data.prop,
        order = data.order;
      if (prop === 'name') {
        order === 'ascending' ? this.query.sort = 'name:asc' : this.query.sort = 'name:desc';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.query.sort = 'createdAt:asc' : this.query.sort = 'createdAt:desc';
      }
      this.doSearch(1);
    }
  }
};